"use client";

import { usePathname } from "next/navigation";
import PremiumNavigation from "./PremiumNavigation";
import InstallAppButton from "@/components/ui/InstallAppButton";

export default function ConditionalNavigation() {
  const pathname = usePathname();

  // Hide PremiumNavigation on builder routes (UnifiedBottomBar handles it there)
  if (pathname?.startsWith("/builder")) {
    return null;
  }

  return (
    <PremiumNavigation
      config={{
        customIslands: [
          {
            id: "install-app",
            position: "right",
            enabled: true,
            component: <InstallAppButton />,
          },
        ],
      }}
    />
  );
}

